import { render, staticRenderFns } from "./0494f471-1638-42f2-9096-2c03b9b67683.vue?vue&type=template&id=1c906b5e&scoped=true"
import script from "./0494f471-1638-42f2-9096-2c03b9b67683.vue?vue&type=script&lang=ts"
export * from "./0494f471-1638-42f2-9096-2c03b9b67683.vue?vue&type=script&lang=ts"
import style0 from "./0494f471-1638-42f2-9096-2c03b9b67683.vue?vue&type=style&index=0&id=1c906b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c906b5e",
  null
  
)

export default component.exports